import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { AdminModerationAction, ModerationActionType } from '@/moderation-actions/schemas'

export const MODERATION_ACTIONS_QUERY_KEY = ['admin', 'moderation-actions'] as const

interface UseModerationActionsOptions {
  action?: ModerationActionType
}

/**
 * `GET /admin/moderation-actions` (DEC-ADMIN-005).
 *
 * Paginált audit-trail lista. Az MVP-UI csak az `action`-szűrőt
 * exponálja (a `target_type` + `admin_user_id` szűrők a backend-en
 * elérhetőek, de UI-szintű szűrésük post-MVP — kombinatorikus dropdown +
 * autocomplete extra munka). Sort `created_at DESC + id DESC`.
 */
export function useModerationActions({ action }: UseModerationActionsOptions = {}) {
  return useQuery({
    queryKey: [...MODERATION_ACTIONS_QUERY_KEY, { action: action ?? null }] as const,
    queryFn: async (): Promise<AdminModerationAction[]> => {
      const query = action ? { action } : undefined
      const { data, error } = await apiClient.GET('/admin/moderation-actions', {
        params: query ? { query } : undefined,
      })
      if (error) throw error
      const envelope = data as { data?: AdminModerationAction[] } | undefined
      return envelope?.data ?? []
    },
  })
}
